var exports = {
  "Qs": "x93eb46d8--95ff95--content",
  "Qq": "x93eb46d8--95ff95--text",
  "nf": "x93eb46d8--95ff95--link",
};

module.exports = exports;
